import { css, RuleSet } from 'styled-components'
import { tok } from '../../utils'

export function modDisabled($disabled: boolean): RuleSet<object> {
  return css`
    transition: opacity 0.2s 0s;
    ${$disabled
    && css`
      opacity: ${tok('primitives_opacity_disabled')}%;
      pointer-events: none;
    `}
  `
}
